import React, { useEffect, useState } from "react";
import { Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import "./App.scss";
import Login from "./screens/sharedScreens/auth/login/Login";
import { AuthProvider } from "util/auth";
import { RequireAuth } from "util/RequireAuth";

import { useAuth } from "util/auth";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { title } from "constants/title";
import Blog from "screens/menu/settings/blogs/Blog";
import Events from "screens/menu/settings/events/Events";
import CompanyProfile from "screens/menu/company-profile/CompanyProfile";
import MemberSearch from "screens/menu/memberSearch/MemberSearch";

// for use bootstrap
import "./../node_modules/bootstrap/dist/css/bootstrap.min.css";
import Certificate from "screens/menu/certificate/Certificate";
import AnnouncementDisplay from "screens/menu/settings/announcement/AnnouncementDisplay";
import { Announcement } from "screens/menu/settings/announcement/Announcement";
import ChatAndMeet from "screens/menu/chatAndMeet/ChatAndMeet";
import NewsLetters from "screens/menu/settings/newsLetters/NewsLetters";
import CompanyServices from "screens/menu/settings/companyServices/CompanyServices";
import OwedInvoice from "screens/menu/invoiceManagement/invoiceList/OwedInvoice";
import MyInvoice from "screens/menu/invoiceManagement/invoiceList/MyInvoice";
import NewsLetterSubscribers from "screens/menu/newsLetterSubscribers/NewsLetterSubscribers";
import ContactEnquiry from "screens/menu/contactEnquiry/ContactEnquiry";
import GrievenceRedressal from "screens/menu/grievenceRedressal/GrievenceRedressal";
import FeaturedInNewsLetter from "screens/menu/featuredInNewsLetter/FeaturedInNewsLetter";
import RegisteredMembers from "screens/menu/registeredMembersList/RegisteredMembers";
import Home from "screens/sharedScreens/home/Home";
import InvoiceManagement from "screens/menu/invoiceManagement/InvoiceManagement";
import RequestQuotesOverview from "screens/menu/requestQuotesOverview/RequestQuotesOverview";
import Grievence from "screens/menu/grievenceRedressal/Grievence";
import ViewGrievenceDetails from "screens/menu/grievenceRedressal/ViewGrievenceDetails";
import { NewsAnnouncements } from "screens/menu/newsAnnouncements/NewsAnnouncements";
import ForgetPassword from "screens/sharedScreens/auth/forgotPassword/ForgetPassword";
import MemberBankDetails from "screens/menu/settings/memberBankDetails/MemberBankDetails";
import { FinancialProtection } from "screens/menu/settings/financialProtection/FinancialProtection";
import FinancialProtectionMessage from "screens/menu/settings/financialProtectionMessage/FinancialProtectionMessage";
import UpdateRegisteredMember from "screens/menu/registeredMembersList/UpdateRegisteredMember";
import BranchCompanyProfile from "screens/menu/company-profile/BranchCompanyProfile";
const Dashboard = React.lazy(() =>
  import("screens/sharedScreens/dashboard/Dashboard")
);

function App() {
  const [pageTitle, setPageTitle] = useState("");
  const location = useLocation();
  const preTitle = "1WN :: One World One Network";
  
  // useEffect(() => {
  //   const unloadCallback = (event) => {
  //     event.preventDefault();
  //     event.returnValue = "";
  //     return "";
  //   };

  //   window.addEventListener("beforeunload", unloadCallback);
  //   return () => window.removeEventListener("beforeunload", unloadCallback);
  // }, []);

  useEffect(() => {
    displayTitle();
  }, [location]);

  function displayTitle() {
    const crumbArray = location.pathname.split("/");
    const endPoint = crumbArray[crumbArray.length - 1];
    const displayTitle = title.filter((item) => {
      return item.key === endPoint;
    });
    setPageTitle(
      displayTitle[0] ? preTitle + " - " + displayTitle[0].value : preTitle
    );
  }

  return (
    // <ThemeProvider theme={theme}>
    <AuthProvider>
      <div className="App">
        <HelmetProvider>
          <Helmet>
            <title>{pageTitle}</title>
          </Helmet>

          <link
            href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
            rel="stylesheet"
            integrity="sha384-wvfXpqpZZVQGK6TAh5PVlGOfQNHSoD2xbE+QkPxCAFlNEevoEH3Sl0sibVcOQVnN"
            crossOrigin="anonymous"
          ></link>
          <AppRoutes />
        </HelmetProvider>
      </div>
    </AuthProvider>
    // </ThemeProvider>
  );
}

const SuspenseLayout = () => (
  <React.Suspense fallback={<>Loading...</>}>
    <Outlet />
  </React.Suspense>
);
const RequireAuthLayout = () => (
  <RequireAuth>
    <Outlet />
  </RequireAuth>
);

function AppRoutes() {
  return (
    <>
      <Routes>
        <Route exact path="/" element={<Login />} />
        <Route path="login" element={<Login />} />
        <Route path="forgetpassword" element={<ForgetPassword />} />
        <Route path="home" element={<Home />}>
          {/* Apply lazy loading */}
          <Route element={<SuspenseLayout />}>
            {/* Authenticate, only login user can open the url's */}
            <Route element={<RequireAuthLayout />}>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="blogs" element={<Blog />} />
              <Route path="events" element={<Events />} />
              <Route
                path="invoice-management"
                element={<InvoiceManagement />}
              />
              <Route path="company-profile" element={<CompanyProfile />} />
              <Route path="branch-company-profile" element={<BranchCompanyProfile />} />
              <Route path="uploadcertificate" element={<Certificate />} />
              <Route path="member-search" element={<MemberSearch />} />
              {/* <Route
                path="grievance-redressal"
                element={<GrievenceRedressal />}
              /> */}
              <Route
                path="grievance-redressal"
                element={<Grievence />}
              />
              <Route
                path="view-grievance-details"
                element={<ViewGrievenceDetails />}
              />
              <Route
                path="news-announcements"
                element={<NewsAnnouncements />}
              />
              <Route path="announcements" element={<Announcement />} />
              <Route path="newsletters" element={<NewsLetters />} />
              <Route path="company-services" element={<CompanyServices />} />

              <Route
                path="view-announcement"
                element={<AnnouncementDisplay />}
              />
              <Route path="chat-meet" element={<ChatAndMeet />} />
              <Route path="owedinvoice" element={<OwedInvoice />} />
              <Route path="myinvoice" element={<MyInvoice />} />
              <Route
                path="newsletter-subscribers"
                element={<NewsLetterSubscribers />}
              />
              <Route
                path="request-quote-list"
                element={<RequestQuotesOverview />}
              />
              <Route
                path="featured-in-newsletter"
                element={<FeaturedInNewsLetter />}
              />
              <Route path="contact-enquiry" element={<ContactEnquiry />} />
              <Route
                path="registered-member-list"
                element={<RegisteredMembers />}
              />
              <Route
                path="member-bank-details"
                element={<MemberBankDetails />}
              />
              <Route
                path="financial-protection-guideline"
                element={<FinancialProtection />}
              />
              <Route
                path="financial-protection-guidelines-message"
                element={<FinancialProtectionMessage />}
              />
              <Route
                path="update-membership"
                element={<UpdateRegisteredMember setFlag={true} updateRecord="" />}
              />
            </Route>
          </Route>
        </Route>
        <Route path="*" element={<Login />} />
      </Routes>
    </>
  );
}

// const RoleAuth = ({ roles, children }) => {
//   const auth = useAuth();
//   if (roles.includes(auth.getUserRole())) {
//     return children;
//   } else {
//     return <Navigate to={"/"} />;
//   }
// };

export default App;
